import { fetchCategories } from "../pages/tatvaShots/service";
import useStore from "../store/useStore";

const useCategories = () => {
  const { setTatvaShots } = useStore();

  const getCategories = async () => {
    try {
      const tsCategories = await fetchCategories();
      setTatvaShots({ categories: tsCategories });
      return tsCategories;
    } catch (err) {
      // Handle error
    }
  };

  return { getCategories };
};

export default useCategories;
